<template>
    <v-avatar :color="avatar_color" :size="size" class="my-2 rounded-lg">
        <span v-if="text">{{ text }}</span>
        <component :is="icon" v-else-if="icon" :size="18" />
        <SquircleIcon v-else :size="18" />
    </v-avatar>
</template>

<script setup>
import { computed } from 'vue';
import { SquircleIcon } from 'lucide-vue-next';

const props = defineProps({
    identifier: {
        type: String,
        required: true,
    },
    text: {
        type: String,
        default: undefined,
    },
    size: {
        type: Number,
        default: 40,
    },
    icon: {
        // Now we expect a direct lucide-vue-next component instead of a string or component
        type: Function,
        required: false,
        default: undefined,
    },
    rounded: {
        type: Number,
        default: 1,
    },
});

const avatar_color = computed(() => {
    const vuetifyColors = [
        'red',
        'pink',
        'purple',
        'deep-purple',
        'indigo',
        'blue',
        'light-blue',
        'cyan',
        'teal',
        'green',
        'light-green',
        'lime',
        'yellow',
        'amber',
        'orange',
        'deep-orange',
        'grey',
        'blue-grey',
    ];

    // Get a hash value from the identifier
    const hashValue = customHashCode(props.identifier);

    // Return the color at the calculated index
    return vuetifyColors[Math.abs(hashValue) % vuetifyColors.length];
});

function customHashCode(str) {
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
        const char = str.charCodeAt(i);
        hash = (hash << 5) - hash + char;
        hash = hash & hash; // Convert to a 32-bit integer
    }
    return Math.abs(hash);
}
</script>

<style scoped lang="scss"></style>
